import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from '~/utils/local-storage';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location, context }) => {
    const { auth } = context;
    const user = auth.user;
    const currentPath = location.pathname;

    if (!auth.isAuthenticated) {
      throw redirect({
        // @ts-expect-error
        to: '/auth/login',
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          // @ts-expect-error
          redirect: location.href,
        },
      });
    }

    const invite = getLocalStorageItem<string>('invite');
    if (invite) {
      window.location.href = invite;
      removeLocalStorageItem('invite');
      return;
    }

    if (user?.metadata?.onboarding) {
      return;
    }

    if (currentPath !== '/onboarding' && !currentPath.startsWith('/cli/')) {
      throw redirect({
        to: '/onboarding',
        replace: true,
      });
    }
  },
});
